module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"back":"Voltar","next":"Avançar"},"en-US":{"back":"Back","next":"Next"}}')
  delete Component.options._Ctor
}
